// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-micro-up-down';

export const Component = () => <path d='m12.402 5 4.597 6H8l4.402-6Zm.195 15L8 14h9l-4.403 6Z' />;

export const viewBox = '0 0 25 25';
